import { useEffect, useState } from 'react';
import React from 'react';

import { Button, Form, Input, Space, Spin, message } from 'antd';

import Configurazione from '../../Configurazione';
import sessionManager, { eVariableType } from '../../SessionManager';
import api from '../../api';
import stringres from '../../translations/stringres';
import '../Antd.css';

export default function ClienteAddEdit(props) {
    const { onCancel } = props;
    const { codCliente } = props;
    const { ridotto } = props;

    const [cliente, setCliente] = useState(props.cliente);
    const [classname, setClassname] = useState('');

    const configurazione = Configurazione();
    const [avvia, setAvvia] = useState(false);
    const [form] = Form.useForm();

    const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);

    useEffect(
        function () {
            if (ridotto) setClassname('custom-form-reduced');
            else setClassname('');
        },
        [ridotto]
    );

    function OnFinishok() {
        setAvvia(true);
    }

    useEffect(() => {
        function fetchData() {
            if (cliente != null) {
                form.setFieldValue('ragioneSociale', cliente?.ragioneSociale);
                form.setFieldValue('nome', cliente?.nome);
                form.setFieldValue('cognome', cliente?.cognome);
                form.setFieldValue('posizione', cliente?.posizione);
                form.setFieldValue('partitaIva', cliente?.partitaIva);
                form.setFieldValue('codFiscale', cliente?.codFiscale);
                form.setFieldValue('indirizzo', cliente?.indirizzo);
                form.setFieldValue('localita', cliente?.localita);
                form.setFieldValue('provincia', cliente?.provincia);
                form.setFieldValue('cap', cliente?.cap);
                form.setFieldValue('codNazione', cliente?.codNazione);
                form.setFieldValue('telefono', cliente?.telefono);
                form.setFieldValue('email', cliente?.email);
                return;
            }

            try {
                let restReq = '';
                if (codCliente !== null) restReq = '&codCliente=' + codCliente;

                if (restReq !== '') {
                    api.get(
                        'CRM/Clienti/Scheda?idSocieta=' + sessionManager.get(eVariableType.IDSocieta) + restReq
                    ).then(function (response) {
                        setCliente(response.data.cliente);

                        form.setFieldValue('ragioneSociale', response.data.cliente?.ragioneSociale);
                        form.setFieldValue('nome', response.data.cliente?.nome);
                        form.setFieldValue('cognome', response.data.cliente?.cognome);
                        form.setFieldValue('posizione', response.data.cliente?.posizione);
                        form.setFieldValue('partitaIva', response.data.cliente?.partitaIva);
                        form.setFieldValue('codFiscale', response.data.cliente?.codFiscale);
                        form.setFieldValue('indirizzo', response.data.cliente?.indirizzo);
                        form.setFieldValue('localita', response.data.cliente?.localita);
                        form.setFieldValue('provincia', response.data.cliente?.provincia);
                        form.setFieldValue('cap', response.data.cliente?.cap);
                        form.setFieldValue('codNazione', response.data.cliente?.codNazione);
                        form.setFieldValue('telefono', response.data.cliente?.telefono);
                        form.setFieldValue('email', response.data.cliente?.email);
                    });
                }
            } catch (error) {
                message.error(error, 5);
            }
        }

        fetchData();
    }, [codCliente, cliente, configurazione.apiBaseUrl, form]);

    useEffect(() => {
        async function onFinish() {
            if (!avvia) return;

            setIsLoadingUpdate(true);
            try {
                const cliente = {
                    idSocieta: sessionManager.get(eVariableType.IDSocieta),
                    codCliente: codCliente,
                    ragioneSociale: form.getFieldValue('ragioneSociale'),
                    nome: form.getFieldValue('nome'),
                    cognome: form.getFieldValue('cognome'),
                    posizione: form.getFieldValue('posizione'),
                    partitaIva: form.getFieldValue('partitaIva'),
                    codFiscale: form.getFieldValue('codFiscale'),
                    indirizzo: form.getFieldValue('indirizzo'),
                    localita: form.getFieldValue('localita'),
                    provincia: form.getFieldValue('provincia'),
                    cap: form.getFieldValue('cap'),
                    codNazione: form.getFieldValue('codNazione'),
                    telefono: form.getFieldValue('telefono'),
                    email: form.getFieldValue('email'),
                };

                const result = await api.post('CRM/Clienti/InsertUpdateProspect', cliente);

                if (result != null) {
                    if (result.data != null) {
                        if (!ridotto) {
                            onCancel();
                            message.success(stringres.t('successo'), 5);
                        }
                    } else {
                        message.error(stringres.t('fallimento'), 5);
                    }
                }
            } catch (error) {
                message.error(error.message, 5);
            } finally {
                setIsLoadingUpdate(false);
                setAvvia(false);
            }
        }
        onFinish();
    }, [avvia, configurazione.apiBaseUrl, codCliente, form, ridotto]);

    return (
        <Spin spinning={isLoadingUpdate} size="large">
            <Form
                size={ridotto ? 'small' : 'middle'}
                form={form}
                onFinish={OnFinishok}
                layout="vertical"
                className={classname}
            >
                <Form.Item name="ragioneSociale" label={stringres.t('ragioneSociale')} rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item>
                    <Form.Item className="Form-item-inline2componenti" name="nome" label={stringres.t('nome')}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={{ paddingLeft: '10px' }}
                        className="Form-item-inline2componenti"
                        name="cognome"
                        label={stringres.t('cognome')}
                    >
                        <Input />
                    </Form.Item>
                </Form.Item>
                <Form.Item name="posizione" label={stringres.t('posizione')}>
                    <Input />
                </Form.Item>
                <Form.Item>
                    <Form.Item
                        rules={[{ type: 'email', message: stringres.t('emailnonvalida') }]}
                        className="Form-item-inline2componenti"
                        name="email"
                        label={stringres.t('email')}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={{ paddingLeft: '10px' }}
                        className="Form-item-inline2componenti"
                        name="telefono"
                        label={stringres.t('telefono')}
                    >
                        <Input />
                    </Form.Item>
                </Form.Item>
                <Form.Item>
                    <Form.Item className="Form-item-inline2componenti" name="partitaIva" label={stringres.t('piva')}>
                        <Input maxLength={16} />
                    </Form.Item>
                    <Form.Item
                        style={{ paddingLeft: '10px' }}
                        className="Form-item-inline2componenti"
                        name="codFiscale"
                        label={stringres.t('codicefiscale')}
                    >
                        <Input maxLength={20} />
                    </Form.Item>
                </Form.Item>
                <Form.Item>
                    <Form.Item className="Form-item-inline" name="indirizzo" label={stringres.t('indirizzo')}>
                        <Input />
                    </Form.Item>
                    <Form.Item className="Form-item-inline" name="localita" label={stringres.t('Localita')}>
                        <Input />
                    </Form.Item>
                    <Form.Item className="Form-item-inline" name="provincia" label={stringres.t('Provincia')}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        className="Form-item-inline"
                        style={{ margin: '0px', width: '100px' }}
                        name="cAP"
                        label={stringres.t('CAP')}
                    >
                        <Input maxLength={5} />
                    </Form.Item>
                    <Form.Item
                        className="Form-item-inline"
                        style={{ width: '75px' }}
                        name="codNazione"
                        label={stringres.t('Nazione')}
                        rules={[{ required: true }]}
                    >
                        <Input maxLength={2} />
                    </Form.Item>
                </Form.Item>
                <Form.Item style={{ textAlign: 'end', marginTop: '15px' }}>
                    <Space>
                        <Button style={{ width: '120px' }} type="primary" htmlType="submit">
                            {stringres.t('conferma')}
                        </Button>
                        <Button
                            style={{ width: '120px' }}
                            type="primary"
                            onClick={onCancel}
                            className={ridotto ? 'hidden' : null}
                        >
                            {/* onCancel  */}
                            {stringres.t('annulla')}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Spin>
    );
}
